'use client'

import { ReactNode, Component } from "react";

interface ErrorBoundaryProps {
    fallback: ReactNode;
    children: ReactNode; // Explicitly define children here
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: any, info: any) {
        console.error("Error Boundary Caught an Error:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }
        return this.props.children; // Render the children prop if no error
    }
}

export default ErrorBoundary;
